<template>
	<div class="col-md-6 col-lg-6">
		<b-overlay :show="isOverlay" rounded="sm" spinner-variant="primary" class="h-100">
			<div class="row">
				<div class="col-12">
					<div class="card card-grafica h-100 mb-3">
						<div class="card-body">
							<div class="filtro-grafic" id="grafica_003" v-if="isVisible">
								<div class="row justify-content-start">
									<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
										<form class="form-inline">
											<label class="title-grafic side-l mr-3">Faltas y Atraso</label>
											<label for="">Año</label>
											<select class="form-control ml-2" @change="get_dataSource" v-model="Anio">
												<option value="">Todos</option>
												<option v-for="(item,index) in ListaAnios" :key="index" :value="item">{{item}}</option>
											</select>
										</form>
										<button type="button" class="btn close abs_01" @click="Ocultar()"><i class="fal fa-times"></i></button>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-10 col-sm-10 col-md-8 col-lg-8">
									<h6 class="title-grafic side-l">Faltas y Atraso</h6>
								</div>
								<div class="col-2 col-sm-2 col-md-4 col-lg-4 text-right">
									<button
										type="button"
										class="btn-fil-002"
										title="Filtros"
										@click="mostrarfiltro()"
									>
										<i class="fas fa-filter"></i>
									</button>
								</div>
								<div class="col-12 col-sm-12 col-md-12 col-lg-12">
									<hr />
								</div>
							</div>
							<div style="height:281px">
                                <jscharting :mutable="false" ref="chart4" :options="chartOptions" class="ml-0 pl-0 columnChart3"></jscharting>
                            </div>
						</div>
					</div>
				</div>
			</div>
		</b-overlay>
	</div>
</template>

<script>
export default {
	name:'Ausencias',
	data() {
		return {
			isVisible: false,
			isOverlay: false,
			Anio:'',
			ListaAnios:[],
			chartOptions:{
				debug:false,
                type:'line',
				legend_visible:true,
				legend:{
					position:'bottom center',
					template: '%icon,%name',
				},
				yAxis:{
            	    // scale_range:{min:0, padding:0.1,max:100},
            	    // orientation:'opposite',
                    formatString: 'n0',
            	},
				defaultPoint: { 
            	    outline_width: 0, 
            	    tooltip: '<b>%yValue</b>',
            	},
				defaultTooltip_label_text: '%points',
				defaultSeries:{
					type:'line',
					line:{
						width:4
					},
					defaultPoint_marker: { 
    				  type: 'circle', 
    				  size: 8,  
    				  outline: { width: 2, color: 'currentColor' } 
    				} 
					// defaultPoint_marker: { 
    				//   fill: 'lightenMore', 
    				//   outline: { width: 1 } 
    				// } 
				},
            	series:[
					{
						name:'Atrasos',
						points:[
							['Ene',0],
							['Feb',0],
							['Mar',0],
							['Abr',0],
							['May',0],
							['Jun',0],
							['Jul',0],
							['Ago',0],
							['Sep',0],
							['Oct',0],
							['Nov',0],
							['Dic',0],
						]
					},
					{
						name:'Faltas',
						points:[
							['Ene',0],
							['Feb',0],
							['Mar',0],
							['Abr',0],
							['May',0],
							['Jun',0],
							['Jul',0],
							['Ago',0],
							['Sep',0],
							['Oct',0],
							['Nov',0],
							['Dic',0],
						]
					}
				]
			}
		}
	},
	methods: {
		async ListYears(){
			await this.$http.get("funciones/getanios").then(res => {
				//console.log('Calling Years');
				this.ListaAnios = res.data.ListaAnios;
				this.Anio = res.data.AnioActual;
			}).finally(()=>{
				this.get_dataSource();
			});
		},
		mostrarfiltro() {
			this.isVisible = true;
		},
		Ocultar() {
			this.isVisible = false;
		},
		async get_dataSource(){
			this.isOverlay = true;
			await this.$http.get("checkinretardos",{
				params: {
					Anio:this.Anio,
				}
			}).then((res)=>{
				this.chartOptions.series[0].points=res.data.data.retardos;
				this.chartOptions.series[1].points=res.data.data.ausencias;	
			}).finally(()=>{
				this.isOverlay = false;
			})
		}
	},
	mounted() {
		this.ListYears();
	},
}
</script>

<style>

</style>
